import Vue from 'vue'
import Router from 'vue-router'
import Contact from './views/Contact.vue'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
		},
		{
			path: '/portfolio',
			name: 'portfolio',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ './views/Portfolio.vue')
		},
		{
			path: '/add',
			name: 'add',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ './views/Add.vue')
		},
		{
			path: '/admin',
			name: 'admin',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ './views/Admin.vue')
		}
	]
})
